import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react';
import styled from 'styled-components';
import CountriesMenu from 'components/CountriesMenu';
import MapOfEurope from 'components/MapOfEurope';
import MapOverlay from 'components/MapOverlay';
import {AppContext} from 'AppContext';

import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/zoom.css';
import 'flag-icons/css/flag-icons.min.css';

const MapScreen = ({path}: {path: string}) => {
  const [country, setCountry] = useState<string | null>(null);
  const [leftSide, setLeftSide] = useState(true);

  const {screenSize, setCustomNavElement} = useContext(AppContext);
  const r = useMemo(() => screenSize[1] && screenSize[0] / screenSize[1], [screenSize]);
  const screenRatioClass = useMemo(
    () => 'ratio-' + (r > 1.22 ? 'wide' : r > 1 ? 'std' : 'narrow'),
    [r],
  );

  const selectCountry = useCallback(
    (newCountry: string | null, leftSide?: boolean) => {
      if (newCountry !== country) {
        setCountry(newCountry);
        setLeftSide(!!leftSide);
      }
    },
    [country],
  );

  useEffect(() => {
    setCustomNavElement(<CountriesMenu path={path} selectCountry={selectCountry} />);
    return () => setCustomNavElement(null);
  }, [setCustomNavElement, selectCountry, path]);

  return (
    <MapContainer className={'map-container ' + screenRatioClass}>
      <MapOfEurope country={country} selectCountry={selectCountry} />
      {country && <MapOverlay path={path} country={country} leftSide={leftSide} />}
    </MapContainer>
  );
};
export default MapScreen;

const MapContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &.ratio-wide {
    align-items: flex-end;
  }

  &.ratio-narrow {
    background-color: var(--color-blue);
  }
`;
